import API from "@/services/api/api.service";
import { RouteLocationNormalized } from "vue-router";

export const rolesResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        const res = await API.getRoles();
        to.meta.roles = res.data.data ?? [];
    } catch(error) {
        console.error('ROLES_RESOLVER_ERROR');
        return { name: 'Welcome' };
    }
}